import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { SecureRedirectService } from '@app/core/services/secure-redirect/secure-redirect.service';
import { EnvironmentService } from '@app/core/environment.service';

@Injectable({
  providedIn: 'root',
})
export class RedirectUriGuard {
  env = inject(EnvironmentService);
  secureRedirect = inject(SecureRedirectService);

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const params = route.queryParams;
    const redirect_uri = this.secureRedirect.sanitizeUrl(params.redirect_uri);
    const redirect_uri_after_registration = this.secureRedirect.sanitizeUrl(
      params.redirect_uri_after_registration,
    );
    if (!redirect_uri && !redirect_uri_after_registration) {
      window.location.href = this.env.getGlobalRedirectURI();
      return false;
    }
    return true;
  }
}
